import { useEffect } from "react";
import { useConsent } from "./ConsentContext";
import { siteConfig } from "../config/siteConfig";

// Loads optional trackers ONLY when (a) the user has consented to the relevant
// category AND (b) a real tracking ID is configured in siteConfig. With the
// current null IDs, nothing loads regardless of consent — by design.
function loadGA(id) {
  if (window.__ga_loaded || !id) return;
  window.__ga_loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
}

function loadMetaPixel(id) {
  if (window.__meta_loaded || !id) return;
  window.__meta_loaded = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

export function TrackingLoader() {
  const { consent } = useConsent();

  useEffect(() => {
    const apply = (c) => {
      if (!c) return;
      if (c.analytics && siteConfig.tracking.googleAnalyticsId) {
        loadGA(siteConfig.tracking.googleAnalyticsId);
      }
      if (c.marketing && siteConfig.tracking.metaPixelId) {
        loadMetaPixel(siteConfig.tracking.metaPixelId);
      }
    };
    apply(consent);
    const handler = (e) => apply(e.detail);
    window.addEventListener("wanm-consent-change", handler);
    return () => window.removeEventListener("wanm-consent-change", handler);
  }, [consent]);

  return null;
}

export default TrackingLoader;
